export default "__VITE_ASSET__Bt9um$SD__"